import { SocketPayload } from '@shared/models';
import React, { createContext } from 'react';
import ReconnectingWebSocket from 'reconnecting-websocket';
import { SocketManager } from '../providers/socket.provider';
import { getWebSocketUrl } from '../providers/sub-domain.service';

let socketManager: SocketManager;
let SocketContext: React.Context<SocketManager | null>;
let SocketContextProvider: React.Provider<SocketManager | null>;
let SocketContextConsumer: React.Consumer<SocketManager | null>;

function initializeWebSocket() {
  if (socketManager) {
    return;
  }

  const socket = new ReconnectingWebSocket(getWebSocketUrl());

  socket.onopen = (event: any) => {
    console.log('Socket connected successfully', { event });
  };

  socket.onmessage = (event: MessageEvent<any>) => {
    const payload: SocketPayload<any> = JSON.parse(event.data);
    console.log('Socket Event', payload);

    const subscriptions = socketManager.subscriptions.get(payload.name) ?? [];
    console.log('# of Subscriptions', subscriptions?.length ?? 0);

    subscriptions.forEach((sub) => sub(payload));
  };

  socketManager = new SocketManager(socket);
  SocketContext = createContext<SocketManager | null>(null);
  SocketContextProvider = SocketContext.Provider;
  SocketContextConsumer = SocketContext.Consumer;
}

export { SocketContext, SocketContextConsumer, SocketContextProvider, initializeWebSocket, socketManager };

